import _slicedToArray from "/Users/andrewgallagher/Documents/eth/highrises/static-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useReducer } from 'react';
import { useEthers } from '../../hooks';
import { NotificationsContext } from './context';
import { DEFAULT_NOTIFICATIONS } from './model';
import { notificationReducer } from './reducer';
import { nanoid } from 'nanoid';
export function NotificationsProvider(_ref) {
  var children = _ref.children;

  var _useReducer = useReducer(notificationReducer, DEFAULT_NOTIFICATIONS),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      notifications = _useReducer2[0],
      dispatch = _useReducer2[1];

  var _useEthers = useEthers(),
      chainId = _useEthers.chainId,
      account = _useEthers.account;

  useEffect(function () {
    if (account && chainId) {
      dispatch({
        type: 'ADD_NOTIFICATION',
        chainId: chainId,
        notification: {
          type: 'walletConnected',
          id: nanoid(),
          submittedAt: Date.now(),
          address: account
        }
      });
    }
  }, [account, chainId]);
  var addNotification = useCallback(function (_ref2) {
    var notification = _ref2.notification,
        chainId = _ref2.chainId;
    dispatch({
      type: 'ADD_NOTIFICATION',
      chainId: chainId,
      notification: Object.assign(Object.assign({}, notification), {
        id: nanoid()
      })
    });
  }, [dispatch]);
  var removeNotification = useCallback(function (_ref3) {
    var notificationId = _ref3.notificationId,
        chainId = _ref3.chainId;
    dispatch({
      type: 'REMOVE_NOTIFICATION',
      chainId: chainId,
      notificationId: notificationId
    });
  }, [dispatch]);
  return _jsx(NotificationsContext.Provider, {
    value: {
      addNotification: addNotification,
      notifications: notifications,
      removeNotification: removeNotification
    },
    children: children
  });
}